// Action Types
export const SHOW_MODAL = 'marketplace/modal/SHOW_MODAL';
export const HIDE_MODAL = 'marketplace/modal/HIDE_MODAL';

// Action Creators
export const showModal = modalProps => ({
    type: SHOW_MODAL,
    payload: modalProps,
});

export const hideModal = () => ({
    type: HIDE_MODAL,
});

// Reducer
const initialState = {
    isOpen: false,
    modalProps: {},
};

export default function modalReducer(state = initialState, action = {}) {
    switch (action.type) {
        case SHOW_MODAL:
            return { isOpen: true, modalProps: action.payload };
        case HIDE_MODAL:
            return { isOpen: false, modalProps: {} };
        case '@@router/LOCATION_CHANGE': // ✅ auto-close modal on route change
            return { isOpen: false, modalProps: {} };
        default:
            return state;
    }
}
